export default __webpack_public_path__ + "img/feec14cc011cf5e5961c446b703977ed.svg";